import * as Models from "../ts/rlAdmin.models";
import * as Utils from "../ts/rlAdmin.utils";
import * as Consts from "../ts/rlAdmin.consts";
import * as _ from "lodash";
import * as angular from "angular";
import { EntityConfigService } from "../services/entity-config-service";
import { BulkUploadService } from "../services/bulk-upload-service";
import { NotifyService } from "../services/notify-service";
import { StorageService } from "../services/storage-service";
import { EntityService } from "../services/entity-service";
import { CurrencyConversionService } from "../services/currency-conversion-service";
import { AclService } from "../services/acl-service";


export function RLBulkImportV3() {
	var directive: ng.IDirective = {
		restrict: "EA",
		template: require("/assets/app/templates/bulk-import-v3.html"),
		controllerAs: "biv3VM",
		controller: BulkImportV3Controller,		
		bindToController: true
	}
	return directive;
}

export class BulkImportV3Controller {
	static $inject = ["$scope", "$location", "$window", "$q", "$log", "$sce", "entityConfigService", "bulkUploadService", "notifyService", "storage", "entityService", "currencyConversionService", "aclService"];
	
	pickedFile: IFilestackPickFile;
	selectedFileName: string;
	selectedDateFormat: string;
	showJobProgressStatus: boolean;
	progressStatus: string;
	resultMessage: string;
	jobId: string;
	jobTitle: string;

	constructor(private $scope: ng.IScope,
		private $location: ng.ILocationService,
		private $window: ng.IWindowService,
		private $q: ng.IQService,
		private $log: ng.ILogService,
		private $sce: ng.ISCEService,
		private entityConfigService: EntityConfigService,
		private bulkUploadService: BulkUploadService,
		private notifyService: NotifyService,
		private storage: StorageService,
		private entityService: EntityService,
		private currencyConversionService: CurrencyConversionService,
		private aclService: AclService) {

		this.selectedDateFormat = "mm/dd/yyyy";
		this.showJobProgressStatus = false;
		this.progressStatus = "";
		this.resultMessage = "";
		this.jobId = "";
		this.jobTitle = "";		

		$scope.$watch(() => this.pickedFile, (newValue, oldValue) => {
			if (newValue != oldValue && newValue != null) {
				this.selectedFileName = newValue[0].key;
				this.Import();
			}
		}, true);

		$scope.$watch(() => this.progressStatus, (newValue, oldValue) => {
			if (newValue != oldValue && (newValue == "Done" || "Failed")) {
				if (newValue == "Failed") {
					this.notifyService.notifyError(this.resultMessage);
				}
				else if (newValue == "Done") {
					this.showJobProgressStatus = false;
					this.ResetAll();
				}
			}
		});
	}	

	Import() {
		this.notifyService.startProgress();
		var parentCharTypeID = 0;		
		this.bulkUploadService.DoBulkImportV3(Consts.CharTypeIDs.right, this.selectedFileName, this.selectedDateFormat)
			.then((result) => {
				alert("Your records are now importing. You will receive an email notification once the job completes and all records have been made visible (re-indexed).  In the meantime, you can perform another import or leave this page and continue working elsewhere.");
				this.showJobProgressStatus = true;
				this.jobId = result.jobID;
				this.jobTitle = result.jobTitle;
			})
			.finally(() => {
				this.notifyService.endProgress();
			});
	}

	ResetAll() {		
		this.showJobProgressStatus = false;		
	}
}
